<template>
  <div class="p-3" v-if="Object.keys(notifications).length">
    <div class="m-0 p-0">
      <h5 class="text-body font-weight-bold">
        {{ formatLongDate(notifications.date) }}
      </h5>
      <div class="m-0" v-for="(type, index) in notifications.types" :key="index">
        <div
          v-b-toggle="`collapse-group-${notification.date + index}`"
          class="text-capitalize d-flex align-items-center justify-content-between text-body font-weight-bold mb-3"
          @click.stop
        >
          <p class="m-0">{{ type.type }}</p>
          <span class="material-icons">expand_more</span>
        </div>
        <b-collapse
          :id="`collapse-group-${notification.date + index}`"
          class="text-body"
          :visible="visible"
        >
          <notification-items
            :notifications="type.notifications"
            @onNotification="clickNotification"
            :isParent="isParent"
            @onAccept="(notification) => $emit('onAcceptItem', notification, type.type, true)"
            @onReject="(notification) => $emit('onRejectItem', notification, type.type, false)"
            @allNotificationsHaveBeenViewed="allNotificationsHaveBeenViewed"
          >
          </notification-items>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import { formatLongDate } from '@/common/utils';
import NotificationItems from './NotificationItems.vue';
export default {
  components: { NotificationItems },
  props: {
    notification: {
      type: Object,
      default: () => ({ date: '', types: [{ type: '', notifications: [] }] }),
    },
    collapseId: [String, Number],
    isParent: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      notifications: this.notification,
    };
  },
  methods: {
    clickNotification(item) {
      this.$emit('onReadNotification', { item });
    },
    formatLongDate,
    allNotificationsHaveBeenViewed(empty) {
      if (empty) this.notifications = {};
    },
  },
};
</script>

